module.exports = __webpack_public_path__ + "static/media/SC-Logo.63628e9a.png";